/**
 * Module responsible for all http related handling.
 * @module services
 * @preferred
 */

 import { AxiosResponse } from 'axios';
 import axiosInstance from './axiosInstance';
 import IResponsePayload from './IResponsePayload';
 import { ResponseStatus } from './IResponsePayload';
 import RequestPayload from './RequestPayload';
 import IHttpOptions from './IHttpOptions';
 import _ from 'lodash';
 import sToast from '@/services/sToast';
 import ProgressBar from '@/services/progressBar';
 import LoaderMobile from "@/services/loaderMobile";
 import router from "@/router";
 import store from '@/store';
 import singletons from './singletons';
 
 const  multiPartFormUrls =['uploadMasterData','uploadFile','commissionUploadDataMaster']
 /**
  * Function to make all posts requests in application. Handles all negative cases.
  *
  * @author davinder.singh
  * @param {IHttpOptions} httpOptions Options that are to be passed to make a request
  * @returns {Promise<any>} Promise that will resolve with payload of successful request.
  */
 function post(httpOptions: IHttpOptions): Promise<any> {
   httpOptions.headers = httpOptions.headers || {};
  // httpOptions.headers.mock = true;
   let requestPayload = null;
   let processedOptions:any =null;
   if(!multiPartFormUrls.includes(httpOptions.url)){
     requestPayload=new RequestPayload(httpOptions);
     _.each(httpOptions.data, (value, key) => {
       requestPayload[key] = value;
   });
   processedOptions = {
     ...httpOptions,
     data:requestPayload
   };
   }else{
     processedOptions={...httpOptions};
   }
   let originalHttpPromise = axiosInstance(processedOptions);
   let handledPromise = originalHttpPromise
     .then(handleSuccess(httpOptions))
     .catch(handleCatch(httpOptions));
   if(singletons['_progressBar']){
     ProgressBar.startAuto(handledPromise, true);
   }
   return handledPromise;
 }
 
 let core = {
   post
 };
 export default core;
 
 function handleSuccess(
   httpOptions: IHttpOptions
 ): ((value: AxiosResponse<any>) => any) | null | undefined {
   return (response: AxiosResponse<IResponsePayload<any>>) => {
     if(response.data.responseStatus == ResponseStatus.success){
      return response.data;
     }
     else if(response.data.responseCode == '099'){
       return Promise.reject(response);
     }
     else if (response.data.responseStatus == ResponseStatus.failure) {
       return Promise.reject(response);
     } else {
      return Promise.reject(response);
     }
   };
 }
 
 function handleCatch(
   httpOptions: IHttpOptions
 ): ((reason: any) => PromiseLike<never>) | null | undefined {
   return response => {
     LoaderMobile.hide();
     response.request = response.request || {};
    if (response.request.status == 200) {
       response.errorMessage = response.data.msgDesc
         ? response.data.msgDesc
         : response.data.responseDesc;
     } else {
       //todo report to sentry or logger
       response.errorMessage = "Something wet wrong, please try again later.";
      
     }
     if (response.data.responseCode.toUpperCase() == 'ISID') {
       store.dispatch('updateIsLoginAc', false);
       store.dispatch('updateSuperInitDataAc', null);
       router.replace({ name: "login" });
     }
     else if (
       response.data.responseCode == '099'
     ) {
       store.dispatch('updateIsLoginAc', false);
       store.dispatch('updateSuperInitDataAc', null);
       router.replace({ name: "login" });
       setTimeout(()=>{
        window.location.reload();
      },500)
   }
     if (response.errorMessage) {
       sToast.show({
         message: response.errorMessage,
         intent: "error",
         timeout: 6000
       });
     }
     return Promise.reject(response);
   };
 }
 